import { render, staticRenderFns } from "./studios-details.vue?vue&type=template&id=643543be&scoped=true"
import script from "./studios-details.vue?vue&type=script&lang=js"
export * from "./studios-details.vue?vue&type=script&lang=js"
import style0 from "./studios-details.vue?vue&type=style&index=0&id=643543be&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643543be",
  null
  
)

export default component.exports